import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GtagService } from 'app/services/gtag.service';
import { PlanPayment } from 'app/entities';
import { PlanSubscription } from 'app/entities/plan-subscription';

@Component({
  selector: 'app-plan-card',
  templateUrl: './plan-card.component.html',
  styleUrls: ['./plan-card.component.scss']
})
export class PlanCardComponent implements OnInit {


  isTooltipVisible: boolean = false;
  featuresExpanded = false;
  expandedFeatures: { [key: string]: boolean } = {};


  @Input("planPayment") planPayment!: PlanPayment;
  @Input("currentSubscription") currentSubscription?: PlanSubscription;
  constructor(
    private _router: Router,
    private _gtag: GtagService
  ) { }

  ngOnInit(): void {
  }

  visibleFeatures() {
    return this.planPayment?.plan?.features?.filter(feature => feature?.showOnPlanCard !== false) ?? [];
  }

  featureKey(feature: any): string {
    return `${feature?.id || feature?.slug || feature?.name}`;
  }

  featureTitle(feature: any): string {
    return feature?.type === 'marketing'
      ? feature?.name
      : (feature?.description || feature?.name);
  }

  featureDetails(feature: any): string | null {
    return feature?.type === 'marketing'
      ? feature?.description
      : feature?.information;
  }

  isFeatureAbsent(feature: any): boolean {
    return feature?.label === 'false';
  }

  hasQuantity(feature: any): boolean {
    return !['true', '*', 'false'].includes(`${feature?.label}`);
  }

  toggleFeatureDetails(feature: any): void {
    const key = this.featureKey(feature);
    this.expandedFeatures[key] = !this.expandedFeatures[key];
  }

  isFeatureDetailsExpanded(feature: any): boolean {
    return !!this.expandedFeatures[this.featureKey(feature)];
  }

  toggleFeatures(): void {
    this.featuresExpanded = !this.featuresExpanded;
  }


  planRedirect(){
    const item = {
      item_id: `PLAN_PAYMENT_ID_${this.planPayment?.id}`,
      item_name: this.planPayment?.name,
      item_brand: this.planPayment?.plan?.slug ?? this.planPayment?.slug,
      item_category: 'subscription_plan',
      price: this.planPayment?.price,
      quantity: 1,
      item_variant: `${this.planPayment?.invoiceInterval ?? ''} ${this.planPayment?.invoicePeriod ?? ''}`.trim(),
    };

    this._gtag.event('select_plan', {
      event_category: 'engagement',
      event_label: `Visualização do plano ${this.planPayment?.slug}`,
      plan_payment_id: this.planPayment?.id,
      plan_slug: this.planPayment?.plan?.slug ?? this.planPayment?.slug,
      price: this.planPayment?.price,
      invoice_interval: this.planPayment?.invoiceInterval,
      invoice_period: this.planPayment?.invoicePeriod
    });

    this._gtag.event('select_item', {
      event_category: 'ecommerce',
      event_label: `Plano selecionado ${this.planPayment?.slug}`,
      item_list_name: 'planos_checkout',
      items: [item]
    });
    this._router.navigate(['/planos-de-assinatura/checkout/'+ this.planPayment?.plan?.slug+'/'+this.planPayment?.slug])

  }

  isCurrentPlanPayment(): boolean {
    return this.planPayment?.currentPlanPaymentId == this.planPayment?.id;
  }

  canRenewCurrentPlan(): boolean {
    return this.isCurrentPlanPayment() && !!this.currentSubscription?.canRenew;
  }

  renew() {
    this._gtag.event('plan_renew', {
      event_category: 'ecommerce',
      event_label: 'Dispara ao clicar no botão Renovar Plano dentro da página Plano',
    });

    this._router.navigate(['/planos-de-assinatura/checkout/retry']);
  }

   

  showTooltip() {
    this.isTooltipVisible = true;
  }

  hideTooltip() {
    this.isTooltipVisible = false;
  }
}
